import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <h1 className="text-[100px] font-bold leading-none text-[#324A5A]">404</h1>
      <p className="mt-4 text-xl font-semibold text-[#324A5A]">
        Halaman tidak ditemukan
      </p>
      <p className="mt-2 max-w-md text-slate-500">
        Halaman yang kamu cari mungkin sudah dipindahkan, dihapus, atau URL-nya salah ketik.
      </p>

      <Link
        to="/Home"
        className="mt-8 rounded-full bg-[#3DA4A8] px-8 py-3 font-semibold text-white transition-all hover:bg-[#2F8C90] hover:shadow-lg">
        Kembali ke Home
      </Link>
    </div>
  );
}
